var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeiboMobileShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 11,
  viewBox: "0 0 13 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.5 0v1H1v9h11V5h1v3.504A2.5 2.5 0 0 1 10.493 11H2.507A2.5 2.5 0 0 1 0 8.504V2.496A2.5 2.5 0 0 1 2.507 0zM13 0v3.5h-1v-2L4.5 9 4 8.35 11.35 1H9V0z"
})));
export default SvgWeiboMobileShare;